<h1>Edit Complaint - {{ complain.title }}</h1>

<form [formGroup]="editComplaintForm" (ngSubmit)="onSubmit()">
    <div class="validation-summary-errors" *ngIf="editComplaintForm.touched && editComplaintForm.invalid">
        <ul>
            <li *ngIf="editComplaintForm.touched && editComplaintForm.controls['branchId'].invalid">Branch can't be empty.</li>
            <li *ngIf="editComplaintForm.touched && editComplaintForm.controls['title'].invalid">Title can't be empty.</li>
            <li *ngIf="editComplaintForm.touched && editComplaintForm.controls['subTitle'].invalid">SubTitle can't be empty.</li>
            <li *ngIf="editComplaintForm.touched && editComplaintForm.controls['customerName'].invalid">Customer Name can't be empty.</li>
            <li *ngIf="editComplaintForm.touched && editComplaintForm.controls['customerPhone'].invalid">Customer Phone can't be empty.</li>
            <li *ngIf="editComplaintForm.touched && editComplaintForm.controls['description'].invalid">Description can't be empty.</li>
            <li *ngIf="editComplaintForm.touched && editComplaintForm.controls['status'].invalid">Status can't be empty.</li>
        </ul>
    </div>
    <div class="form-group">
        <label for="branchId">Branch</label>
        <ng-select
            [items]="branches"
            bindLabel="branchName"
            bindValue="branchId"
            formControlName="branchId"
            class="w-md-25"
            [ngClass]="{
                'input-validation-error': editComplaintForm.touched && editComplaintForm.controls['branchId'].invalid,
                'disabled-ng-select': !isWhoCreatedCom
            }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="title">Title</label>
        <ng-select
            [items]="compliansTitles"
            bindLabel="name"
            bindValue="value"
            formControlName="title"
            class="w-md-25"
            [ngClass]="{
                'input-validation-error': editComplaintForm.touched && editComplaintForm.controls['title'].invalid,
                'disabled-ng-select': !isWhoCreatedCom
            }"
            (change)="onChange($event)"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="subTitle">SubTitle</label>
        <ng-select
            [items]="compliansSubTitlesCurrent"
            bindLabel="name"
            bindValue="value"
            formControlName="subTitle"
            class="w-md-25"
            [ngClass]="{
                'input-validation-error': editComplaintForm.touched && editComplaintForm.controls['subTitle'].invalid,
                'disabled-ng-select': !isWhoCreatedCom
            }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="customerName">Customer Name</label>
        <input
            id="customerName"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="customerName"
            [ngClass]="{
                'input-validation-error': editComplaintForm.touched && editComplaintForm.controls['customerName'].invalid,
                'disabled-input': !isWhoCreatedCom
            }"
        />
    </div>
    <div class="form-group">
        <label for="customerPhone">Customer Phone</label>
        <input
            id="customerPhone"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="customerPhone"
            [ngClass]="{
                'input-validation-error': editComplaintForm.touched && editComplaintForm.controls['customerPhone'].invalid,
                'disabled-input': !isWhoCreatedCom
            }"
        />
    </div>
    <div class="form-group">
        <label for="status">Status</label>
        <ng-select
            [items]="compliansStatus"
            bindLabel="name"
            bindValue="value"
            formControlName="status"
            class="w-md-25"
            [ngClass]="{
                'input-validation-error': editComplaintForm.touched && editComplaintForm.controls['status'].invalid,
                'disabled-ng-select': isCanceledOrCompleted
            }"
        >
        </ng-select>
    </div>
    <div class="form-group">
        <label for="description">Description</label>
        <textarea
            rows="5"
            id="description"
            class="form-control w-md-25"
            autofocus="autofocus"
            type="text"
            formControlName="description"
            [ngClass]="{ 'input-validation-error': editComplaintForm.touched && editComplaintForm.controls['description'].invalid }"
        >
        </textarea>
    </div>

    <div class="form-group">
        <div class="asset-container">
            <div class="asset-container-header">Complain Details</div>
            <div class="asset-container-content">
                <table class="section-products-table table">
                    <tbody>
                        <tr *ngFor="let item of compliansDetails">
                            <td>
                                {{ item.status }}
                            </td>
                            <td>
                                {{ item.description }}
                            </td>
                            <td>
                                {{ item.createdBy.substring(0, item.createdBy.lastIndexOf('@')) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="form-group">
        <button class="btn btn-primary btn-sm" type="submit" [disabled]="formBusy" *ngIf="!isCanceledOrCompleted">Save</button>
        <button class="btn btn-secondary btn-sm ml-2" type="button" (click)="location.back()">Cancel</button>
    </div>
</form>
